export default "__VITE_ASSET__bDC1hZkF__"